module.exports = __webpack_public_path__ + "assets/img/二维码@2x.b5f38c19.png";